<template>
  <div class="datepicker">
    <datepicker-header
      :calender="calender"
      @updateMonth="updateMonth"
      @updateYear="updateYear"
    />

    <datepicker-body
      :calender="calender"
      :value="activeDate"
      :is-null="isNull"
      @updateDay="updateDay"
      @updateMonth="updateMonth"
    />

    <div class="datepicker-footer">
      <button
        :class="'set-today-button'"
        v-text="$t('kitComponents.datePicker.today')"
        @click="setCurrentDate"
      />
      <button
        :class="productClass"
        v-text="$t('kitComponents.datePicker.apply')"
        @click="emitDate"
      />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import * as _ from 'lodash'
import * as moment from 'moment'

import Locales from '../../../localization/Locales'

import DatepickerHeader from '../datepicker/DatepickerHeader'
import DatepickerBody from '../datepicker/DatepickerBody'

export default {
  name: 'Datepicker',
  components: {
    'datepicker-header': DatepickerHeader,
    'datepicker-body': DatepickerBody
  },

  i18n: {
    messages: Locales
  },

  data () {
    return {
      calender: moment().startOf('day').toObject(),
      activeDate: moment().startOf('day').toObject(),
      calenderPicked: true
    }
  },
  props: {
    date: {
      default: function () {
        return moment().toObject()
      },
      type: Object
    }
  },
  computed: {
    productClass () {
      return 'snagstream-button'
    },
    selectedDate () {
      let self = this
      return self.activeDate
    },
    selectedMoment () {
      let self = this
      let result = moment(self.selectedDate)
      return result.startOf('day')
    },
    isNull () {
      let self = this
      let result = false

      if (!self.calenderPicked) {
        _.forEach(self.date, value => {
          if (value === null) {
            result = true
          }
        })
      }
      return result
    }
  },
  methods: {
    updateYear (newYear) {
      let self = this
      if (newYear !== null) {
        Vue.set(self.calender, 'years', newYear)
      }
    },
    updateMonth (newMonth) {
      let self = this
      let newValue = moment(self.calender)

      switch (newMonth) {
        case -1:
          newValue = newValue.subtract(1, 'month')
          break
        case 12:
          newValue = newValue.add(1, 'month')
          break
        default:
          newValue = newValue.month(newMonth)
      }
      newValue = newValue.startOf('day')

      Vue.set(self, 'calender', newValue.toObject())
    },
    updateDay (newDay) {
      let self = this
      if (newDay !== null) {
        self.calenderPicked = true
        let newMoment = moment([self.calender.years, self.calender.months, newDay])
        Vue.set(self, 'activeDate', newMoment.startOf('day').toObject())
      }
    },
    emitDate () {
      let self = this
      self.$emit('emitValue', self.selectedDate)
    },
    setCurrentDate () {
      let self = this
      Vue.set(self, 'calender', moment().startOf('day').toObject())
      self.updateDay(self.calender.date)
    }
  },
  watch: {
    date: {
      handler: function (newValue) {
        let self = this

        self.calenderPicked = false

        if (newValue.years) {
          self.updateYear(newValue.years)
        }
        if (newValue.months) {
          self.updateMonth(newValue.months)
        }
        if (newValue.date) {
          self.updateDay(newValue.date)
        }
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
  /*@import "~ui.kit.styling";*/
  @import '../uikit';

  .datepicker {
    background-color: white;
    max-width: 275px;

    datepicker-body {
      max-width: 275px;
    }

    .datepicker-footer {
      display: block;
      height: 100px;
      padding: 0 25px 25px 25px;

      button {
        width: 100%;
        height: 50px;
        font-family: 'Roboto' !important;
        font-weight: 500 !important;

        &.set-today-button {
          font-size: 13px;
          color: $lightGreyFont;
          background-color: white;

          &:hover {
            color: $mediumGreyFont;
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// node_modules/pro4all-ui/sns-components/kit-components/ui-kit/Datepicker.vue